import { Box, List, ListItemButton, ListItemText, Slider, Typography } from '@mui/material';
import { DEVICES, DeviceMode } from './previewDevices';

interface PreviewDeviceListProps {
  activeDevice: DeviceMode;
  onDeviceChange: (device: DeviceMode) => void;
  customWidth: number;
  onCustomWidthChange: (width: number) => void;
}

function PreviewDeviceList({ activeDevice, onDeviceChange, customWidth, onCustomWidthChange }: PreviewDeviceListProps) {
  return (
    <Box sx={{ width: 180, minWidth: 180, backgroundColor: 'background.paper', borderRight: '1px solid', borderColor: 'divider', overflowY: 'auto' }}>
      <List disablePadding>
        {DEVICES.map(device => {
          const selected = activeDevice === device.key;
          return (
            <ListItemButton
              key={device.key}
              selected={selected}
              onClick={() => onDeviceChange(device.key)}
              sx={{
                flexDirection: 'column',
                alignItems: 'flex-start',
                py: 1.5,
                px: 2,
                borderBottom: '1px solid',
                borderColor: 'grey.200',
                '&.Mui-selected': { backgroundColor: 'primary.main', color: 'common.white', '&:hover': { backgroundColor: 'primary.main' } },
              }}
            >
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="caption" fontWeight={700} sx={{ fontSize: '0.68rem', letterSpacing: 0.3, color: selected ? 'common.white' : 'text.primary' }}>
                    {device.label}
                  </Typography>
                }
                secondary={device.subtitle && (
                  <Typography variant="caption" sx={{ fontSize: '0.65rem', color: selected ? 'rgba(255,255,255,0.8)' : 'text.disabled', fontStyle: 'italic' }}>
                    {device.subtitle}
                  </Typography>
                )}
              />
            </ListItemButton>
          );
        })}
      </List>

      {activeDevice === 'custom' && (
        <Box sx={{ px: 2, pt: 1.5 }}>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem', fontStyle: 'italic', display: 'block', mb: 0.5 }}>
            Taille de l&apos;écran : {customWidth} px
          </Typography>
          <Slider
            value={customWidth}
            min={320}
            max={1600}
            step={10}
            onChange={(_, value) => onCustomWidthChange(value as number)}
            size="small"
            sx={{ color: 'primary.main' }}
          />
        </Box>
      )}
    </Box>
  );
}

export default PreviewDeviceList;
